import {createPostRequest, makeRequest} from "../utils/apiUtil";

export function create(params) {
    return makeRequest(createPostRequest('subscription'), params);
}